import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m365.3 93.38-74.63-74.64C278.6 6.742 262.3 0 245.4 0H64C28.65 0 0 28.65 0 64l.007 384c0 35.34 28.65 64 64 64H320c35.2 0 64-28.8 64-64V138.6c0-16.9-6.7-33.2-18.7-45.22M336 448c0 8.836-7.164 16-16 16H64.02c-8.838 0-16-7.164-16-16L48 64.13c0-8.836 7.164-16 16-16h160V128c0 17.67 14.33 32 32 32h79.1v288zM171.5 259.5 136 296H92c-6.62 0-12 5.4-12 12v56c0 6.7 5.38 12 12 12h44l35.5 36.5c7.6 7.5 20.5 2.3 20.5-8.5V268c0-10.7-12.9-16.1-20.5-8.5m63.6 1.2c-6.25 6.25-6.25 16.38 0 22.62.2.18 20.9 21.78 20.9 52.68 0 30.94-20.77 52.53-20.91 52.69-6.25 6.25-6.25 16.38 0 22.62 3.11 3.09 7.21 4.69 11.31 4.69s8.188-1.562 11.31-4.688C258.1 410.1 288 380.5 288 336s-29.05-74.06-30.28-75.31c-6.22-6.29-16.42-6.29-22.62.01",
      style: {"fill":"var(--fa-primary-color, currentColor)","opacity":"var(--fa-primary-opacity, 1)"}
    }, null, -1)
  ])))
}
export default { render: render }